import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../router';
const _preserve = React.version;
//import { useStore } from '../store';sd
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Checkbox, FormField, SpaceBetween, Spinner, Table, Toggle } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';
import { format, parse } from 'date-fns';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading } from '../../../commons/functions';

type ItemCron = {
    idCron: number;
    cron: string;
    url: string;
    lastRun: string;
    nextRun: string;
    lastResult: number;
    isActiveCron: number;
    lastError: string;
    json: any;
    loadingIcon: React.ReactNode;
    loading: boolean;

}

export const SystemCrons = () => {
    const { menu } = useGlobalState();
    const [crons, setCrons] = useState<ItemCron[]>([]);
    const [cron, setCron] = useState<ItemCron>();
    const [onlyActive, setOnlyActive] = useState(true);

    useGlobalState();

    const { navigate } = useRouter();





    const handleUpdateStatus = async (item: ItemCron, isActiveCron: number) => {
        try {
            item.loading = true;
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/crons/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idCron: item.idCron,
                    isActiveCron: isActiveCron,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.crons) {

                const cron2 = data.crons.map((cronItem: ItemCron) => ({
                    ...cronItem,
                    loading: false,       // <-- New Key 1
                    loadingIcon: <Spinner variant="normal" key={`spinner-${cronItem.idCron}`} />    // <-- New Key 2
                }));
                console.log(cron2)
                setCrons(cron2)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            item.loading = false;
        }
    };
    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/crons/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.crons) {

                const cron2 = data.crons.map((cronItem: ItemCron) => ({
                    ...cronItem,
                    loading: false,       // <-- New Key 1
                    loadingIcon: <Spinner variant="normal" key={`spinner-${cronItem.idCron}`} />    // <-- New Key 2
                }));
                setCrons(cron2)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const filteredCrons = onlyActive ? crons.filter(cron => cron.isActiveCron === 1) : crons;
    useEffect(() => {
        console.log(crons)
        if (!crons || crons.length === 0)
            handleRefresh()

    }, []);

    const getFrequencyLabel = (json: { years: number, months: number, days: number, hours: number, minutes: number }) => {
        const parts = [
            json.years > 0 ? `${json.years} año${json.years > 1 ? "s" : ""}` : null,
            json.months > 0 ? `${json.months} mes${json.months > 1 ? "es" : ""}` : null,
            json.days > 0 ? `${json.days} día${json.days > 1 ? "s" : ""}` : null,
            json.hours > 0 ? `${json.hours} hora${json.hours > 1 ? "s" : ""}` : null,
            json.minutes > 0 ? `${json.minutes} minuto${json.minutes > 1 ? "s" : ""}` : null
        ];

        // .filter(Boolean) removes the 'null' entries, .join(' ') combines them
        return parts.filter(Boolean).join(" ");
    };
    return (

        <CustomAppLayout

            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={

                <SpaceBetween size="s">
                    <Header
                        description={<Checkbox checked={onlyActive}
                            onChange={(e) => {
                                setOnlyActive(e.detail.checked)
                            }}
                        >Solo los CRONS activos</Checkbox>}
                        actions={<Favorites />} variant="h1">
                        <SpaceBetween size="s" direction="vertical" alignItems="center">
                            CRONS de servicio
                        </SpaceBetween>
                    </Header>

                    <Table
                        stripedRows
                        variant="embedded"
                        columnDefinitions={[
                            {
                                id: 'idCron',
                                header: 'CRON',
                                cell: (item: ItemCron) => (

                                    <FormField
                                        label={item.cron}>
                                        {item.url}
                                    </FormField>
                                )
                            },
                            {
                                id: 'last',
                                header: 'Uº Ejecución',
                                cell: (item: ItemCron) => (

                                    <FormField
                                        label={item.lastRun !== "" ? format(parse(item.lastRun, "dd-MM-yyyy HH:mm", new Date()), "HH:mm") : ""}>
                                        {item.lastRun !== "" ? format(parse(item.lastRun, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") : ""}

                                    </FormField>
                                )
                            },
                            {
                                id: 'lastResult',
                                header: 'Uº resultado',
                                cell: (item: ItemCron) => (
                                    item.lastResult
                                )
                            },
                            {
                                id: 'Pº ejecución',
                                header: 'Pº ejecución',
                                cell: (item: ItemCron) => (

                                    <FormField
                                        label={item.nextRun !== "" ? format(parse(item.nextRun, "dd-MM-yyyy HH:mm", new Date()), "HH:mm") : ""}>
                                        {item.nextRun !== "" ? format(parse(item.nextRun, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") : ""}
                                    </FormField>
                                )
                            },
                            {
                                id: 'emTo',
                                header: 'Frecuencia',
                                cell: (item: ItemCron) => <>
                                    {getFrequencyLabel(item.json)}
                                </>
                            },
                            {
                                id: 'active',
                                header: <Button onClick={() => handleRefresh()} style={{ root: btnIconForm }}><Icon path={mdiRefresh} size={1} /></Button>,
                                cell: (item: ItemCron) => {
                                    // 💡 FIX: Check the 'loading' property of the current row item.
                                    return item.loading === false
                                        ? (
                                            <Toggle
                                                onChange={({ detail }) => {
                                                    if (detail && item) {

                                                        const updatedCrons = crons.map((cron) => {
                                                            if (cron.idCron === item.idCron) {
                                                                // 2. Return a new object for the modified item
                                                                return { ...cron, loading: true };
                                                            }
                                                            return cron;
                                                        });
                                                        setCrons(updatedCrons)
                                                        handleUpdateStatus(item, detail.checked ? 1 : 0)
                                                    }
                                                }}
                                                checked={item.isActiveCron === 1}
                                            />
                                        )
                                        : item.loadingIcon; // Display the loading icon if item.loading is true (or undefined/null if you rely on the initial mapping)
                                },
                                maxWidth: 80
                            },
                        ]}
                        items={filteredCrons}
                    />
                </SpaceBetween>
            }
        />

    );
};
